<template>
  <div ref="regalosRef" class="mesa-regalos-section">
    <img src="@/assets/sello.avif" alt="Sello decorativo" class="sello-superior" />

    <h2 class="mesa-titulo animate-item">
      Mesa <span class="script">de Regalos</span>
    </h2>

    <p class="mesa-descripcion animate-item">
      Para nosotros el mejor regalo es celebrar juntos nuestro amor en este aniversario. Sin embargo, si deseas tener un detalle con nosotros, te dejamos estas opciones con mucho cariño, sin ser en lo absoluto una obligación.
    </p>
 
    <img src="@/assets/SOBRE.avif" class="sobre-icono animate-item" alt="Sobre decorativo" />

    <p class="nota-extra animate-item">
      Lluvia de sobres el día del evento.
    </p>

    <div class="separador-regalo animate-item" aria-hidden="true">
      <span class="rombo-separador">✦</span>
    </div>

    <div class="bloque-regalo-fisico animate-item">
      <h3 class="titulo-regalo-fisico">Regalo Físico</h3>
      <p class="descripcion-regalo-fisico">
        Si prefieres entregarnos un detalle de forma física, contaremos con un espacio especial asignado para recibirlo el día de nuestra celebración.
      </p>
    </div>

    <div class="bloque-imagen-final animate-item">
      <img src="@/assets/regalo.png" class="regalo-final-img" alt="Icono de regalo" />
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'MesaRegalos',
  setup() {
    const regalosRef = ref(null)

    onMounted(() => {
      nextTick(() => {
        const elementosAnimados = regalosRef.value.querySelectorAll('.animate-item')

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Animación individual e independiente al hacer scroll
              gsap.fromTo(
                entry.target,
                { opacity: 0, y: 30, scale: 0.98 },
                {
                  opacity: 1,
                  y: 0,
                  scale: 1,
                  duration: 0.8,
                  ease: 'power2.out',
                }
              )
              observer.unobserve(entry.target)
            }
          })
        }, { threshold: 0.15 }) // Se redujo el threshold para asegurar el disparo en móviles

        elementosAnimados.forEach((el) => observer.observe(el))
      })
    })

    return {
      regalosRef
    }
  }
}
</script>

<style scoped>
.mesa-regalos-section {
  background-color: #817b76;
  color: #f1e9dc;
  font-family: 'Playfair Display', serif;
  width: 90%;
  margin: 0 auto;
  border-radius: 80px 0 0 80px;
  padding: 100px 30px 60px;
  position: relative;
  text-align: center;
  /* Se eliminó 'top: 50px' para quitar la franja o espacio oscuro extraño de abajo */
}

.sello-superior {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  width: 90px;
  height: auto;
  z-index: 2;
}

.mesa-titulo {
  font-size: 2.4rem;
  font-weight: bold;
  margin-bottom: 40px;
  color: white;
  margin-right: -10px;
  font-family: 'subtitulos';
}

.script {
  font-family: 'corinthia';
  font-size: 2.4rem;
  color: #e7d8cb;
  font-weight: normal;
  margin-left: 8px;
}

.mesa-descripcion {
  font-family: 'Poppins', sans-serif;
  font-size: 14px !important;
  line-height: 1.8;
  letter-spacing: 1px;
  color: #e2d8cb;
  margin-bottom: 40px;
  text-transform: none;
}

.sobre-icono {
  width: 90px;
  height: auto;
  margin: 40px 0 20px;
}

.nota-extra {
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  color: #f1e9dc;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.separador-regalo {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 20px;
  margin: 30px auto 20px;
}

.separador-regalo::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(231, 216, 203, 0.6) 50%, transparent);
}

.rombo-separador {
  font-size: 11px;
  color: #e7d8cb;
  background-color: #817b76;
  padding: 0 8px;
  z-index: 1;
}

.bloque-regalo-fisico {
  margin-top: 10px;
  padding: 0 10px;
  margin-bottom: 30px;
}

.titulo-regalo-fisico {
  font-family: 'corinthia', cursive;
  font-size: 2.6rem !important;
  color: #e7d8cb;
  font-weight: normal;
  margin: 0 0 10px 0;
}

.descripcion-regalo-fisico {
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  line-height: 1.7;
  letter-spacing: 0.5px;
  color: #e2d8cb;
  max-width: 280px;
  margin: 0 auto;
}

/* Estilos de la nueva imagen final */
.bloque-imagen-final {
  margin-top: 25px;
  display: flex;
  justify-content: center;
}

.regalo-final-img {
  width: 150px;
  height: auto;
  opacity: 0.85;
}

.animate-item {
  opacity: 0;
  transform: translateY(30px);
  will-change: transform, opacity;
}
</style>